var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-filter-group mb-1" }, [
    _c(
      "button",
      {
        staticClass: "product-filter-group__button",
        attrs: {
          "aria-controls": "filter-group--capacity",
          "aria-expanded": "true",
          "data-target": "#filter-group--capacity",
          "data-toggle": "collapse",
          role: "button",
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.labels.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "collapse show py-1",
        attrs: { id: "filter-group--capacity" },
      },
      [
        _c(
          "ul",
          { staticClass: "nav align-items-center ml-1 form-group--unit" },
          [
            _c("li", { staticClass: "form-group__label" }, [
              _c("label", [_vm._v(_vm._s(_vm.labels.unit))]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.options, function (option) {
              return _c(
                "li",
                { key: option.key, staticClass: "form-group__input" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.unit,
                        expression: "unit",
                      },
                    ],
                    staticClass: "d-none",
                    attrs: {
                      type: "radio",
                      name: "unit",
                      id: "unit--" + option.value,
                    },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.unit, option.value),
                    },
                    on: {
                      change: function ($event) {
                        _vm.unit = option.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "unit--" + option.value } }, [
                    _vm._v(_vm._s(option.label)),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "nav align-items-sm-center ml-1 form-group--capacity",
          },
          [
            _c("li", { staticClass: "form-group__label" }, [
              _c("label", { attrs: { for: "input--capacity" } }, [
                _vm._v(_vm._s(_vm.labels.label)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "d-sm-flex d-md-block form-group__input" },
              [
                _c("div", { staticClass: "input-wrapper mb-1" }, [
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "input--capacityMin" },
                    },
                    [_vm._v(_vm._s(_vm.labels.min_cap))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.capacityMin,
                        expression: "capacityMin",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", id: "input--capacityMin" },
                    domProps: { value: _vm.capacityMin },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.capacityMin = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.labels.range_keyword))]),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "input--capacity" },
                    },
                    [_vm._v(_vm._s(_vm.labels.max_cap))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.capacity,
                        expression: "capacity",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: {
                      type: "number",
                      min: _vm.capacityMin,
                      id: "input--capacity",
                    },
                    domProps: { value: _vm.capacity },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.capacity = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.labels.units[_vm.unit]) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn--orange-o",
                    attrs: { disabled: _vm.disabled },
                    on: { click: _vm.add },
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.labels.submit) + "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }